import { normalizeLabel } from 'myst-common';
export const embedDirective = {
    name: 'embed',
    arg: {
        type: String,
        required: true,
    },
    options: {
        'remove-input': {
            type: Boolean,
        },
        'remove-output': {
            type: Boolean,
        },
    },
    run(data) {
        var _a, _b;
        if (!data.arg)
            return [];
        const argString = data.arg;
        const arg = argString.startsWith('#') ? argString.substring(1) : argString;
        const { label } = normalizeLabel(arg) || {};
        if (!label)
            return [];
        return [
            {
                type: 'embed',
                source: { label },
                'remove-input': (_a = data.options) === null || _a === void 0 ? void 0 : _a['remove-input'],
                'remove-output': (_b = data.options) === null || _b === void 0 ? void 0 : _b['remove-output'],
            },
        ];
    },
};
